// 封装请求方法
import requset from '@/utils/request.js'

export const getDataType = (data) =>{
    return requset({
        url:`/xwzx/system/dict/data/type/${data}`,
        method:'GET'
    })
}
export const regionList = (data) =>{
    return requset({
        url:`/xwzx/region/list`,
        method:'GET',
        data
    })
}
export const expertInfoSave = (data) =>{
    return requset({
        url:'/xwzx/expert/info',
        method:'post',
        data
    })
}
// 全球行政区划列表
export const allGlobalRegionList = (data) =>{
    return requset({
        url:'/xwzx/global/region/allGlobalRegionList',
        method:'get'
    })
}
// 获取所属行业数据
export const normList = (data) =>{
    return requset({
        url:'/xwzx/norm/list',
        method:'get'
    })
}
// 新增企业信息
export const enterpriseInfoSave = (data) =>{
    return requset({
        url:'/xwzx/enterprise/info',
        method:'post',
        data
    })
}